import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var leaderBoardPointsRes;
export const leaderBoardPointsTodo = createAsyncThunk('leaderBoardPoints', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/get_points_by_users',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return leaderBoardPointsRes = res.data
    } catch (error) {
        return leaderBoardPointsRes = error.response.data
    }
})


const leaderBoardPointsSlice = createSlice({
    name: 'leaderBoardPoints',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(leaderBoardPointsTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('leaderBoardPoints', state.data)
            }
        });
        builder.addCase(leaderBoardPointsTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default leaderBoardPointsSlice.reducer; 